import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
    return (
        <div className="font-sans text-gray-800 bg-[#FAFCFF] flex flex-col min-h-screen">
            <Navbar />

            <main className="flex-grow w-full py-16 md:py-24">
                <div className="max-w-[1280px] mx-auto px-6 md:px-12">
                    <div className="mb-10 md:mb-12">
                        <h1 className="text-4xl md:text-5xl font-bold text-[#005AAC] mb-4 tracking-tight">
                            Privacy Policy of WamGlammz
                        </h1>
                        <p className="text-gray-500 text-lg">
                            Last updated: April 2026
                        </p>
                    </div>

                    <div className="bg-white p-8 md:p-12 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 max-w-5xl">
                        <div className="space-y-8 text-[16px] text-gray-700 leading-relaxed">
                            <p>
                                Wamglammz LLC operates the https://wamglammz.com website, which provides the SERVICE.
                            </p>

                            <p>
                                This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service "WamGlammz".
                            </p>

                            <p>
                                If you choose to use our Service, then you agree to the collection and use of information in relation with this policy. We collect the Personal Information for transactions, using our service and order purposes. We will not use or share your information with anyone except as described in this Privacy Policy.
                            </p>

                            <p>
                                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at https://wamglammz.com unless otherwise defined in this Privacy Policy. Our Privacy Policy was created with the help of the Privacy Policy Template and the Disclaimer Generator.
                            </p>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Information Collection and Use</h2>
                                <p>We collect any user information for service usage.</p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Log Data</h2>
                                <p>
                                    We want to inform you that whenever you visit our Service, we do not collect information that your browser sends to us that is called Log Data. This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Cookies</h2>
                                <p className="mb-3">
                                    Cookies are files with small amount of data that is commonly used an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.
                                </p>
                                <p>
                                    Our website uses these "cookies" to collection information and to improve our Service. You have the option to either accept or refuse these cookies, and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.
                                </p>
                                <p className="mt-3">For more general information on cookies, please read "What Are Cookies".</p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Service Providers</h2>
                                <p className="mb-3">We may employ third-party companies and individuals due to the following reasons:</p>
                                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                                    <li>To facilitate our Service;</li>
                                    <li>To provide the Service on our behalf;</li>
                                    <li>To perform Service-related services; or</li>
                                    <li>To assist us in analyzing how our Service is used.</li>
                                </ul>
                                <p className="mt-3">
                                    We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Security</h2>
                                <p>
                                    We value your trust but we do not collect any user information. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Links to Other Sites</h2>
                                <p>
                                    Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over, and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Children's Privacy</h2>
                                <p>
                                    Our Services do not address anyone under the age of 18. We do not knowingly collect personal identifiable information from children under 18. In the case we discover that a child under 18 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Changes to This Privacy Policy</h2>
                                <p>
                                    We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately, after they are posted on this page.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-3">Contact Us</h2>
                                <p className="mb-2">If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</p>
                                <a href="mailto:info@wamglammz.com" className="text-[#005AAC] hover:underline font-semibold">
                                    info@wamglammz.com
                                </a>
                            </section>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
